import { useServicesChartsDataContext } from '../../../hooks/useServicesChartsDataContext';
import {
    getSelectedYearMonths,
    monthsIndexes
} from '../../../../Util/getMonthsByYear';
import { defaultColors } from '../../../contexts/ServicesChartsDataContext';

const useServicesPerMonthPerYearPercentageChart = () => {
    const { subtitles, chartData, filters } = useServicesChartsDataContext();

    const months = getSelectedYearMonths(filters);

    const totalPerMonth = months.map((month) => {
        const found = chartData.selectedYear
            .filter(
                (counter) =>
                    parseInt(counter.mes_competencia, 10) ===
                    monthsIndexes[month]
            )
            .reduce((acc, curr) => acc + Number(curr.services), 0);

        return found ? Number(found) : 0;
    });

    const series = subtitles.map((item) => {
        const data = months.map((month, index) => {
            if (totalPerMonth[index] === 0) {
                return 0;
            }

            const found = chartData.selectedYear.find(
                (counter) =>
                    (counter.description ?? '-') === item &&
                    parseInt(counter.mes_competencia, 10) ===
                        monthsIndexes[month]
            );

            return found
                ? (
                      (Number(found.services) / totalPerMonth[index]) *
                      100
                  ).toFixed(2)
                : 0;
        });

        return {
            name: item,
            data
        };
    });

    const chartConfig = {
        series: series,
        options: {
            chart: {
                type: 'bar',
                height: 400,
                stacked: true,
                toolbar: {
                    show: true
                }
            },
            plotOptions: {
                bar: {
                    horizontal: false,
                    borderRadius: 4,
                    borderRadiusApplication: 'end',
                    borderRadiusWhenStacked: 'last'
                }
            },
            yaxis: {
                labels: {
                    formatter: (val) => `${val.toFixed(0)}%`
                },
                max: 100
            },
            xaxis: {
                categories: months || []
            },
            legend: {
                position: 'top',
                offsetY: 10
            },
            fill: {
                opacity: 1
            },
            dataLabels: {
                enabled: true,
                formatter: (val) => `${val}%`,
                style: {
                    colors: ['#ffffff'],
                    fontSize: '11px'
                }
            },
            tooltip: {
                y: {
                    formatter: (val) => (val ? `${val.toLocaleString('pt-BR')}%` : '')
                }
            },
            colors: defaultColors,
            grid: {
                show: false
            }
        }
    };

    return {
        chartConfig
    };
};

export default useServicesPerMonthPerYearPercentageChart;
